import { TextTag } from 'ui-toolkit';
import { ExternalOrderStatusTag } from '../../components/clientPortal/clientOrderHeader/ExternalOrderStatusTag';
import React from 'react';
import { eExternalOrderStatus } from '../../ui-toolkit/enums/eExternalOrderStatus';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

export const generateBottomTags = (
  externalStatus: eExternalOrderStatus | null,
  lenderName: string | null,
  dataTestID?: string
): JSX.Element[] | undefined => {
  return [
    <ExternalOrderStatusTag externalStatus={externalStatus} dataTestID={dataTestID} />,
    <TextTag data-test-id={mergeTests(dataTestID, 'lender-name-tag')} text={lenderName || ''} type={'gray'} />,
  ];
};
